import React from 'react'
import { UserPlus } from 'lucide-react';
import { MetricGrid, MetricCard, ActivityChart, C } from './AdminAnalyticsUI';

function AnalyticClientCard({totalCount, xAxisValues, values, rangeLabel}) {
  return (
    <div className='flex flex-col w-full font-plexsans'>
      <MetricGrid cols={3}>
        <MetricCard
          icon={<UserPlus size={16} strokeWidth={2} color={C.green} />}
          tile="rgba(58,125,79,.1)"
          title="Client signups"
          value={totalCount?.users}
          desc="New client accounts created"
        />
      </MetricGrid>
      <ActivityChart
        xAxisValues={xAxisValues}
        rangeLabel={rangeLabel}
        series={[{ label: 'Client signups', color: C.green, data: values?.users }]}
      />
    </div>
  )
}

export default AnalyticClientCard
